import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';
import { IPersonalInformation } from './personal-information.interface';

export interface IPersonalInformationForm extends Omit<IPersonalInformation, 'language'> {
    language: IDynamicKeyValue;
}
